import React from 'react'
import toast from 'react-hot-toast'
import { useCopyToClipboard } from 'react-use'
import { Modal } from './ui/Modal'
import Typography from './ui/Typography'

interface Props {
  shareModal: boolean
  shareModaltoggle: (nextValue?: any) => void
  link: string
}

function CopyModal({ shareModal, shareModaltoggle, link }: Props) {
  const [state, copyToClipboard] = useCopyToClipboard()
  return (
    <Modal
      className='space-y-4 pt-2'
      isOpen={shareModal}
      setIsOpen={shareModaltoggle}
      description={
        <>
          <Typography className='text-secondary' variant='small'>
            لینک ختم
          </Typography>
          <div className='relative'>
            <input
              readOnly
              value={
                link
                // window.location.href.length > 40
                //   ? `${window.location.href.slice(0, 40)}...`
                //   : window.location.href
              }
              className={
                'shadow-1 h-12 w-full rounded-xl bg-onSecondary p-2 text-xs text-secondary placeholder:text-xs placeholder:text-onSecondary-4'
              }
            />
            {/* <i
                className='icon-document-copy absolute left-2 top-2 text-2xl'
                onClick={() => copyToClipboard(window.location.href)}
              /> */}
          </div>
          {/* {state.value && (
              <Typography variant='subTitle' className='text-primary'>
                کپی شد
              </Typography>
            )} */}
        </>
      }
      confirmText='کپی کردن لینک'
      onConfirm={() => {
        copyToClipboard(link)
        toast.success('لینک ختم کپی شد!')
      }}
    />
  )
}

export default CopyModal
